<mat-dialog-content fxLayout="column" fxLayoutAlign="center center">
    <p>
        The search field can search either all fields or a single specified
        field of the activities table. Normal operation searches all fields of
        the activities table for any value that contains the text supplied by
        the user. The user may narrow the scope of the search to a specific
        activity field by using the syntax <b>Keyword : Value</b>. Using this
        method only activities whose <i>Keyword</i> contains the text specified
        by <i>Value</i> will appear in the activities table. To search for an
        exact match, surround the <i>Value</i> term with double quotes. The
        search field only supports a single search term, and thus only one
        <b>Keyword : Value</b> pair may be supplied.
    </p>

    <p>
        Example: There are three activities, each with a specific page number. A
        [page 14], B [page 143], and C [page 114]. The search string
        <i>Page:14</i> will return activities A, B, and C because each has the
        string "14" in the Page field. However the search string
        <i>Page:"14"</i> will only return activity A.
    </p>

    The following keywords are available:
    <mat-list class="search-info-dialog-inline-list">
        <mat-list-item>Title</mat-list-item>
        <mat-list-item>Unit</mat-list-item>
        <mat-list-item>Level</mat-list-item>
        <mat-list-item>Resource</mat-list-item>
        <mat-list-item>Lesson</mat-list-item>
        <mat-list-item>Page</mat-list-item>
        <mat-list-item>Activity Number</mat-list-item>
        <mat-list-item>Activity Title</mat-list-item>
        <mat-list-item>Program</mat-list-item>
        <mat-list-item>Type</mat-list-item>
        <mat-list-item>Activity Type</mat-list-item>
    </mat-list>
    <button mat-raised-button color="primary" (click)="onCancel()">
        Close
    </button>
</mat-dialog-content>
